import {
  CREATE_SEARCH,
  FETCH_RECENT_SEARCHES,
  SET_RECENT_SEARCHES,
} from './actionConstants'
import uuidV4 from 'lib/string/uuidV4Utils'
import { AnyAppAction } from 'actions/types/ActionTypes'
import { deleteRecentSearch, getRecentSearches, saveRecentSearch } from 'components/Search/utils'
import { selectSelectedTravellerEmployees } from 'businessTraveller/selectors/businessTravellerEmployeeSelectors'
import { setFlightSessionRecentSearch } from 'lib/flights/flightUtils'
import { clearBusinessTravellerSelectedTraveller } from 'businessTraveller/storage/businessTravellerStorage'
import setSelectedBusinessTravellersAndGuests from './businessTraveller/setSelectedBusinessTravellerEmployeesAndGuests'

export function createSearch(
  action: { searchKey: string, searchId: string, searchContext?: App.SearchContext, searchEvent?: App.SearchEvent },
) {
  const { searchKey, searchId, searchContext, searchEvent } = action

  return {
    type: CREATE_SEARCH,
    key: searchKey,
    searchContext,
    searchEvent,
    searchId,
  }
}

export function setSearchSession(
  searchKey: string,
  options: { newSearchId?: string, searchContext?: App.SearchContext, searchEvent?: App.SearchEvent } = {},
): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    const { newSearchId, searchContext, searchEvent } = options

    const searchId = state.search.searches[searchKey]?.searchId ?? newSearchId ?? uuidV4()

    dispatch(createSearch({ searchKey, searchId, searchContext, searchEvent }))
  }
}

export function fetchRecentSearches(): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.auth.recentSearches.length > 0) {
      // already updated this, don't need to do it again
      // it should always be in sync after initial fetch
      return
    }

    const recentSearches = getRecentSearches(state.auth.account.memberId)

    dispatch({
      type: FETCH_RECENT_SEARCHES,
      data: recentSearches,
    })
  }
}

export function addRecentSearch(
  searchItem: App.SearchItem,
  dates: App.SearchDates,
  rooms: Array<App.Occupants>,
): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.businessTraveller.employees.status !== 'success') {
      // Employees are not ready yet, so we can't save the recent search
      // This is for the case when users enter the search page via url or refresh the page
      return
    }

    const travellers = selectSelectedTravellerEmployees(state)
    saveRecentSearch(searchItem, dates, rooms, state.auth.account.memberId, travellers)

    dispatch({
      type: SET_RECENT_SEARCHES,
      // our source of truth for recent search is local storage (for now?)
      // so once we save it, get the whole list
      data: getRecentSearches(state.auth.account.memberId),
    })
  }
}

export function removeRecentSearch(
  id: string,
): AnyAppAction {
  return (dispatch, getState) => {
    const state = getState()

    deleteRecentSearch(id, state.auth.account.memberId)

    dispatch({
      type: SET_RECENT_SEARCHES,
      // our source of truth for recent search is local storage (for now?)
      // so once we save it, get the whole list
      data: getRecentSearches(state.auth.account.memberId),
    })
  }
}

export function clearRecentSearches(): AnyAppAction {
  return (dispatch) => {
    dispatch({
      type: SET_RECENT_SEARCHES,
      data: [],
    })
  }
}

export function clearAllSearchState(): AnyAppAction {
  return (dispatch) => {
    // Clear Redux state for recent searches
    dispatch(clearRecentSearches())

    // Clear localStorage flight session data
    setFlightSessionRecentSearch({
      flights: [],
    })

    // local storage
    clearBusinessTravellerSelectedTraveller()
    // redux
    dispatch(setSelectedBusinessTravellersAndGuests([], 0))
  }
}
